import React, { useEffect, useState, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Label,
  FormGroup,
  Input,
  Button
} from "reactstrap";
import Select from "react-select";
import "./index.css";
import api from "../../api";

function ResetPassword() {
  const [isLoading, setIsLoading] = useState(false);

  const [error, setError] = useState(false);
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newConfirmPassword, setNewConfirmPassword] = useState("");

  const resetPassword = () => {
    api.fetchAPI({
      method: "put",
      uri: `userme/reset_password`,
      body: {
        password,
        new_password: newPassword,
        new_confirm_password: newConfirmPassword
      },
      success: response => {
        if (response.status) {
          window.location = `/`;
        } else {
          alert(response.result.message);
        }
      },
      error: error => {
        console.error(error);
      }
    });
  };

  useEffect(() => {}, []);

  return (
    <Container>
      <div className="container">
        <Row>
          <Col sm="12" md={{ size: 8, offset: 2 }}>
            <h2 style={{ textAlign: "center" }}>Đặt lại mật khẩu đăng nhập</h2>
          </Col>
        </Row>
      </div>
      <br />
      <br />
      <Row>
        <Col sm="12" md={{ size: 6, offset: 3 }}>
          <label>Mật khẩu cũ</label>
          <Input
            type="password"
            value={password}
            onChange={e => {
              setPassword(e.target.value);
            }}
          />
        </Col>
      </Row>
      <br />
      <Row>
        <Col sm="12" md={{ size: 6, offset: 3 }}>
          <label>Mật khẩu mới</label>
          <Input
            type="password"
            value={newPassword}
            onChange={e => {
              setNewPassword(e.target.value);
            }}
          />
        </Col>
      </Row>
      <br />
      <Row>
        <Col sm="12" md={{ size: 6, offset: 3 }}>
          <label>Nhập lại mật khẩu mới</label>
          <Input
            type="password"
            value={newConfirmPassword}
            onChange={e => {
              setNewConfirmPassword(e.target.value);
            }}
          />
        </Col>
      </Row>
      <br />
      <br />
      <Row>
        <Col sm="12" md={{ size: 6, offset: 3 }}>
          <Button color="primary" block onClick={resetPassword}>
            Xác nhận
          </Button>
        </Col>
      </Row>
    </Container>
  );
}

export default ResetPassword;
